// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * The following are shared across all platforms and apps
 */
.custom-ui {
  color: var(--undp-jtf-btn-dark-color);
}

.badge {
  font-size: 14px;
}

/* Solo modales de crear/editar informe (windowClass en index + post-detail) */
::ng-deep .post-editor-modal-window {
  /*
   * ng-bootstrap inserta el componente dentro de .modal-content (normalmente como hijo directo).
   * Sin flex en eview-post-editor, el cuerpo no recibe altura acotada y desaparece el scroll.
   */
}
::ng-deep .post-editor-modal-window .modal-dialog.modal-xl {
  display: flex;
  flex-direction: column;
  max-width: min(920px, 100vw - 1.5rem);
  width: min(920px, 100vw - 1.5rem);
  max-height: calc(100vh - 2rem);
  margin: 0.75rem auto;
  min-height: 0;
}
::ng-deep .post-editor-modal-window .modal-content {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  max-height: 100%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
}
::ng-deep .post-editor-modal-window .modal-content eview-post-editor {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}
::ng-deep .post-editor-modal-window .modal-content eview-post-editor > .modal-header {
  flex-shrink: 0;
}
::ng-deep .post-editor-modal-window .modal-content eview-post-editor > .modal-body.post-editor-modal-shell {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0;
}
::ng-deep .post-editor-modal-window .post-editor-modal-shell .searchable-select__clear {
  right: 0.5rem;
}

.post-editor-modal-header {
  display: flex;
  align-items: center;
  padding: 0.875rem 1.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.post-editor-close {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem -0.25rem auto;
  opacity: 0.75;
}
.post-editor-close:hover {
  opacity: 1;
}

.post-editor-modal-shell {
  min-height: 0;
}

.post-editor-toolbar {
  flex-shrink: 0;
  padding: 0.75rem 1.5rem;
  background: #f5f6f8;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.post-editor-main {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  max-width: 100%;
  padding: 0 1.5rem;
  box-sizing: border-box;
  overflow-x: hidden;
}

.post-editor-meta {
  flex-shrink: 0;
  padding-top: 1rem;
}

.post-info {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 0.5rem 0.75rem;
}

.post-single-info {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 5px;
}

/* Una sola columna: mismo orden que el formulario, sin forzar anchos en los hijos */
.post-editor-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  /* Margen derecho extra: scrollbar + botón × del select no pegan al borde */
  padding: 1rem 0.65rem 0.75rem 0;
  scrollbar-gutter: stable;
  -webkit-overflow-scrolling: touch;
}

.post-editor-fields {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.post-editor-field {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
.post-editor-field eview-form-attribute {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.post-editor-management-levels {
  margin-top: -12px;
  margin-bottom: 0.5rem;
  padding-left: 2px;
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.post-editor-footer {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 1rem 0.35rem 1.25rem 0;
  margin-top: auto;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.createNewIncidentLabel {
  font-size: 1.25rem;
  color: var(--undp-jtf-btn-dark-color);
  text-align: left;
  margin: 0;
  line-height: 1.35;
  padding-right: 0.5rem;
}

.borderColorBlack {
  border-color: #000000;
}

.fontSize12 {
  font-size: 12px;
}

.fontSize14 {
  font-size: 14px;
}

.fontSize16 {
  font-size: 16px;
}

::placeholder {
  color: var(--undp-jtf-btn-dark-color);
  text-align: left;
  letter-spacing: 0px;
  opacity: 0.3;
}

.btnSubmit {
  border-radius: 8px;
  min-width: 9rem;
  line-height: 2 !important;
  color: #fff !important;
}

.btn-md-cancel-inform {
  background-color: #9ea3a8 !important;
  color: #fff !important;
}

button.close {
  border: none;
  outline: none;
  background: none;
}

.close {
  font-size: 2rem !important;
  line-height: 1;
  border: none;
  color: var(--undp-jtf-btn-dark-color) !important;
  text-shadow: 0 1px 0 #fff;
}
.close.hover {
  border: none;
}
.close.focus {
  border: none;
}

.fontColorRadioLabel {
  color: var(--undp-jtf-btn-dark-color);
}

.post-editor-btn-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

@media (max-width: 576px) {
  .post-editor-footer {
    flex-direction: column-reverse;
  }
  .post-editor-footer .btn {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/post-editor/post-editor/post-editor-page.component.scss","webpack://./libs/scss/_index.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;ADEA;EACE,qCAAA;AAGF;;AAAA;EACE,eAAA;AAGF;;AAAA,8EAAA;AACA;EAsBE;;;IAAA;AAfF;AANE;EACE,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;EACA,aAAA;AAQJ;AALE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2CAAA;AAOJ;AAAE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;AAEJ;AACE;EACE,cAAA;AACJ;AAEE;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;AAAJ;AAGE;EACE,aAAA;AADJ;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,4CAAA;AAFF;;AAKA;EACE,uBAAA;EACA,sCAAA;EACA,aAAA;AAFF;AAIE;EACE,UAAA;AAFJ;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,4CAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,cAAA;EACA,iBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,QAAA;AAHF;;AAMA,oFAAA;AACA;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,2EAAA;EACA,+BAAA;EACA,wBAAA;EACA,iCAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AAHF;;AAMA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AAHF;AAKE;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AAHJ;;AAOA;EACE,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;AAJF;;AAOA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,+BAAA;EACA,gBAAA;EACA,yCAAA;AAJF;;AAOA;EACE,kBAAA;EACA,qCAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,qBAAA;AAJF;;AAOA;EACE,qBAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,qCAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAJF;;AAOA;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;AAJF;;AAOA;EACE,oCAAA;EACA,sBAAA;AAJF;;AAOA;EACE,YAAA;EACA,aAAA;EACA,gBAAA;AAJF;;AAOA;EACE,0BAAA;EACA,cAAA;EACA,YAAA;EACA,gDAAA;EACA,yBAAA;AAJF;AAME;EACE,YAAA;AAJJ;AAOE;EACE,YAAA;AALJ;;AASA;EACE,qCAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;AANF;;AASA;EACE;IACE,8BAAA;EANF;EAQE;IACE,WAAA;EANJ;AACF","sourcesContent":["@import '../../../../../scss/variables';\n\n.custom-ui {\n  color: var(--undp-jtf-btn-dark-color);\n}\n\n.badge {\n  font-size: 14px;\n}\n\n/* Solo modales de crear/editar informe (windowClass en index + post-detail) */\n::ng-deep .post-editor-modal-window {\n  .modal-dialog.modal-xl {\n    display: flex;\n    flex-direction: column;\n    max-width: min(920px, calc(100vw - 1.5rem));\n    width: min(920px, calc(100vw - 1.5rem));\n    max-height: calc(100vh - 2rem);\n    margin: 0.75rem auto;\n    min-height: 0;\n  }\n\n  .modal-content {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    min-height: 0;\n    max-height: 100%;\n    border-radius: 10px;\n    overflow: hidden;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);\n  }\n\n  /*\n   * ng-bootstrap inserta el componente dentro de .modal-content (normalmente como hijo directo).\n   * Sin flex en eview-post-editor, el cuerpo no recibe altura acotada y desaparece el scroll.\n   */\n  .modal-content eview-post-editor {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .modal-content eview-post-editor > .modal-header {\n    flex-shrink: 0;\n  }\n\n  .modal-content eview-post-editor > .modal-body.post-editor-modal-shell {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n  }\n\n  .post-editor-modal-shell .searchable-select__clear {\n    right: 0.5rem;\n  }\n}\n\n.post-editor-modal-header {\n  display: flex;\n  align-items: center;\n  padding: 0.875rem 1.5rem;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.post-editor-close {\n  padding: 0.25rem 0.5rem;\n  margin: -0.25rem -0.5rem -0.25rem auto;\n  opacity: 0.75;\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.post-editor-modal-shell {\n  min-height: 0;\n}\n\n.post-editor-toolbar {\n  flex-shrink: 0;\n  padding: 0.75rem 1.5rem;\n  background: #f5f6f8;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.post-editor-main {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  min-width: 0;\n  max-width: 100%;\n  padding: 0 1.5rem;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.post-editor-meta {\n  flex-shrink: 0;\n  padding-top: 1rem;\n}\n\n.post-info {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 0.5rem 0.75rem;\n}\n\n.post-single-info {\n  display: inline-flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 5px;\n}\n\n/* Una sola columna: mismo orden que el formulario, sin forzar anchos en los hijos */\n.post-editor-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  /* Margen derecho extra: scrollbar + botón × del select no pegan al borde */\n  padding: 1rem 0.65rem 0.75rem 0;\n  scrollbar-gutter: stable;\n  -webkit-overflow-scrolling: touch;\n}\n\n.post-editor-fields {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.post-editor-field {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n\n  eview-form-attribute {\n    display: block;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n  }\n}\n\n.post-editor-management-levels {\n  margin-top: -12px;\n  margin-bottom: 0.5rem;\n  padding-left: 2px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.post-editor-footer {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  padding: 1rem 0.35rem 1.25rem 0;\n  margin-top: auto;\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.createNewIncidentLabel {\n  font-size: 1.25rem;\n  color: var(--undp-jtf-btn-dark-color);\n  text-align: left;\n  margin: 0;\n  line-height: 1.35;\n  padding-right: 0.5rem;\n}\n\n.borderColorBlack {\n  border-color: #000000;\n}\n\n.fontSize12 {\n  font-size: 12px;\n}\n\n.fontSize14 {\n  font-size: 14px;\n}\n\n.fontSize16 {\n  font-size: 16px;\n}\n\n::placeholder {\n  color: var(--undp-jtf-btn-dark-color);\n  text-align: left;\n  letter-spacing: 0px;\n  opacity: 0.3;\n}\n\n.btnSubmit {\n  border-radius: 8px;\n  min-width: 9rem;\n  line-height: 2 !important;\n  color: #fff !important;\n}\n\n.btn-md-cancel-inform {\n  background-color: #9ea3a8 !important;\n  color: #fff !important;\n}\n\nbutton.close {\n  border: none;\n  outline: none;\n  background: none;\n}\n\n.close {\n  font-size: 2rem !important;\n  line-height: 1;\n  border: none;\n  color: var(--undp-jtf-btn-dark-color) !important;\n  text-shadow: 0 1px 0 #fff;\n\n  &.hover {\n    border: none;\n  }\n\n  &.focus {\n    border: none;\n  }\n}\n\n.fontColorRadioLabel {\n  color: var(--undp-jtf-btn-dark-color);\n}\n\n.post-editor-btn-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n@media (max-width: 576px) {\n  .post-editor-footer {\n    flex-direction: column-reverse;\n\n    .btn {\n      width: 100%;\n    }\n  }\n}\n","/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
